<template>
    <div class="flex flex-col md:flex-row items-stretch"
        :class="[
            no_border ? 'p-0' : 'border-b border-gray-400 py-8',
            label_align_top ? 'md:items-start' : 'md:items-center',
        ]"
    >
        <div v-if="title"
            class="mb-8 md:mb-0 md:w-40 flex-none mr-6"
            :class="label_class"
        >
            <h5 class="font-semibold uppercase tracking-wider text-gray-warm-800 text-xs leading-snug focus:text-red-600 focus:outline-none"
                :class="label_align_top ? 'pt-1' : ''"
                v-html="$t(title.toUpperCase())"
                :id="section_id"
            >
            </h5>
        </div>

        <div v-else
            class="mb-8 md:mb-0 md:w-40 flex-none mr-6"
            :class="label_class"
        >&nbsp;</div>

        <div class="flex flex-col sm:flex-row flex-1 sm:flex-wrap lg:flex-nowrap">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {},
        label_class: {},
        section_id: {},
        no_border: {},
        label_align_top: { default: false },
    },
}
</script>
